export const modules = (state) => state.modules

